import React, { useState, useEffect } from 'react';
import { useSearchkit } from '@searchkit/client';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import { FormikWrapper, FormSelect, ApiAutocomplete } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const RADIUS_DEFAULT = 5000;

export const LocationSearch = ({ defaultValue = '', labelKey = 'search_nldoet.location.placeholder', onChange }) => {
  const API_URL = config.get('API_URL');
  const { t } = useTranslation();

  return (
    <div className="FormElement">
      <label htmlFor="LocationSearch">{t('search_nldoet.location.label')}</label>
      <ApiAutocomplete
        key={`item--${defaultValue}`}
        id="LocationSearch"
        endpoint={`${API_URL}/api/autocomplete`}
        defaultValue={defaultValue}
        renderItem={(item) => {
          return <div className="LocationSearch__item">{item.name} <span className="LocationSearch__item__type">{item.type === 'gemeente' && <span>Gemeente</span>} ({item.gemeente})</span></div>;
        }}
        onSelectItem={(item) => {
          onChange(item);
        }}
        placeholder={t(labelKey)}
      />
    </div>
  );
};

const Search = ({ initialValues }) => {
  const { t } = useTranslation();
  const api = useSearchkit();
  const [area, setArea] = useState(initialValues.area);
  const [radius, setRadius] = useState(RADIUS_DEFAULT);
  const [bounds, setBounds] = useState(null);
  const [areaName, setAreaName] = useState(initialValues.area_name);

  const changeArea = (_area) => {
    if (!_area) {
      return;
    }

    setAreaName(_area.name);

    setArea({
      lat: _area.lat,
      lon: _area.lon,
    });

    setBounds({
      topLeft: {
        lat: _area.bounds.NE.lat,
        lon: _area.bounds.SW.long,
      },
      bottomRight: {
        lat: _area.bounds.SW.lat,
        lon: _area.bounds.NE.long,
      },
    });
  };

  const changeRadius = (_radius) => {
    if (_radius === 0) {
      setRadius(RADIUS_DEFAULT);
    } else {
      setRadius(_radius * 1000);
    }
  };

  useEffect(() => {
    if (area) {
      api.removeFiltersByIdentifier('radius');
      api.addFilter({
        identifier: "radius",
        geoRadius: {
          radius: radius || RADIUS_DEFAULT,
          center: {
            lat: area.lat,
            lon: area.lon,
          },
        },
      });
    }

    if (bounds) {
      api.removeFiltersByIdentifier('fake_box');
      api.addFilter({
        identifier: "fake_box",
        geoBoundingBox: bounds,
      });
    }

    if (areaName) {
      api.removeFiltersByIdentifier('area_name');
      api.addFilter({
        identifier: "area_name",
        value: areaName,
      });
    }

    api.setPage({ from: 0 });
    api.search();
  }, [api, radius, area, bounds, areaName]);

  return (
    <div className="Search">
      <FormikWrapper initialValues={initialValues}>
        <LocationSearch
          onChange={changeArea}
          defaultValue={areaName}
        />
        <FormSelect
          title={t('search_nldoet.distance.label')}
          fieldName="radius"
          placeholder={t('search_nldoet.distance.placeholder')}
          options={{
            0: '+ 0 km',
            1: '+ 1 km',
            2: '+ 2 km',
            3: '+ 3 km',
            4: '+ 4 km',
            5: '+ 5 km',
            8: '+ 8 km',
            10: '+ 10 km',
            15: '+ 15 km',
            30: '+ 30 km',
            100: '+ 100 km',
          }}
          onChange={changeRadius}
        />
      </FormikWrapper>
      <CoreLink href="/resultaten-op-naam">
        {t('search_nldoet.search_on_organisation')}
      </CoreLink>
    </div>
  );
};

export default Search;
